import { gql } from "@apollo/client";
import { Database } from "@nozbe/watermelondb";
import { LayoutNodeFilterDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNodeDeepNestingFragment,
  LayoutNodeLinkDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNode as LayoutNodeEntity,
  LayoutNodeInput,
} from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import {
  default as LayoutNode,
  default as LayoutNodeModel,
} from "../../data/model/LayoutNode";
import { AsyncLayoutActionDefinition } from "../types";

export const createLayoutNodeMutation = gql`
  ${LayoutNodeFilterDeepNestingFragment}
  ${LayoutNodeLinkDeepNestingFragment}
  ${LayoutNodeDeepNestingFragment}
  mutation CreateLayoutNode($input: LayoutNodeInput!) {
    createLayoutNode(input: $input) {
      ...LayoutNodeDeepNesting
    }
  }
`;

export const createLayoutKeyDefinition = new AsyncLayoutActionDefinition<
  LayoutNodeEntity,
  LayoutNodeModel,
  (
    database: Database,
    layoutKeyInput: LayoutNodeInput
  ) => Promise<LayoutNodeModel>,
  (layoutKey: any) => Promise<LayoutNodeEntity>
>({
  localAction: async (database: Database, layoutKeyInput: LayoutNodeInput) => {
    return database.write(async () => {
      return database.collections
        .get<LayoutNode>("layout_nodes")
        .create((layoutNode) => {
          if (layoutKeyInput.id) {
            layoutNode._raw.id = layoutKeyInput.id;
          }
          layoutNode.layout.id = layoutKeyInput.layoutId || null;
          layoutNode.label = layoutKeyInput.label || null;
          layoutNode.color = layoutKeyInput.color;
          layoutNode.showImage = layoutKeyInput.showImage || false;
          layoutNode.productId = layoutKeyInput.productId || null;
          layoutNode.type = layoutKeyInput.type || null;
          layoutNode.position = layoutKeyInput.position || 0;
          layoutNode.action = layoutKeyInput.action || null;
          layoutNode.link = layoutKeyInput.link || null;
          layoutNode.filter = layoutKeyInput.filter || null;
          layoutNode.labelColor = layoutKeyInput.labelColor || null;
        });
    });
  },
  remoteAction: async (layoutKeyInput: LayoutNodeInput) => {
    return client
      .mutate({
        variables: { input: layoutKeyInput },
        mutation: createLayoutNodeMutation,
      })
      .then((result) => {
        return result.data?.createLayoutNode;
      });
  },
});
